const anthemSongs = [
  {
    id: 1,
    name: "Anthem",
    songCount: 42,
    icon: "🚗",
    gradient: "from-sky-500 to-indigo-500",
    bgGradient: "from-sky-50 to-indigo-50",
    songs: [
      {
        subCategory: "Hindi",
        songList: [
          {
            title: "Motivational",
            id: "anthem-1",
            url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Corporate-anthem/Hindi_anthem_1.mp3",
          },
          {
            title: "Sports",
            id: "anthem-2",
            url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Corporate-anthem/Hindi_anthem_2.mp3",
          },
          {
            title: "Manufacturer",
            id: "anthem-3",
            url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Corporate-anthem/Hindi_anthem_3.mp3",
          },
          {
            title: "Motivational",
            id: "anthem-4",
            url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Corporate-anthem/Hindi_anthem_4.mp3",
          },
          {
            title: "Education",
            id: "anthem-5",
            url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Corporate-anthem/Hindi_anthem_5.mp3",
          },
          {
            title: "Community",
            id: "anthem-6",
            url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Corporate-anthem/Hindi_anthem_6.mp3",
          },
        ],
      },
      {
        subCategory: "English",
        songList: [
          {
            title: "Nation",
            id: "anthem-1",
            url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Corporate-anthem/English_anthem_1.mp3",
          },
          {
            title: "Motivational",
            id: "anthem-2",
            url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Corporate-anthem/English_anthem_2.mp3",
          },
          {
            title: "Motivational",
            id: "anthem-3",
            url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Corporate-anthem/English_anthem_3.mp3",
          },
        ],
      },
    ],
    image: "/images/jingle_categories/corporate_anthem.webp",
  },
];

export default anthemSongs;
